import "./Switch.css";

export default function Switch({
    value = false,
    onChange,
    disabled = false,
    name,
    size = "md", // "xs" | "sm" | "md" | "lg"
}) {
    return (
        <button
            type="button"
            name={name}
            className={`sw ${size} ${value ? "is-on" : "is-off"} ${disabled ? "is-disabled" : ""
                }`}
            role="switch"
            aria-checked={value}
            aria-disabled={disabled}
            onClick={() => !disabled && onChange(!value)}
        >
            <span className="sw__thumb" />
        </button>
    );
}